var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temLinhas
    ? _c(
        "div",
        { staticClass: "chat-indice-artefatos" },
        [
          _c(
            "transition",
            { attrs: { name: "iv2-indice-artefatos" } },
            [
              _vm.compacta
                ? _c("ChatIndiceArtefatosCompacta", {
                    key: "compacta",
                    staticClass: "chat-indice-artefatos__cartao",
                    attrs: { linhas: _vm.linhas },
                    on: {
                      abrir: _vm.abrir,
                      fechar: _vm.fecharArtefato,
                      expandir: _vm.expandir
                    }
                  })
                : _c(
                    "nav",
                    {
                      key: "cartao",
                      staticClass: "chat-indice-artefatos__cartao px-2 pb-2",
                      class: {
                        "chat-indice-artefatos__cartao--condensado":
                          _vm.condensada,
                        "chat-indice-artefatos__cartao--sobreposto":
                          _vm.sobreposto
                      },
                      style: _vm.estiloDoCartao,
                      attrs: {
                        "aria-label": _vm.titulo,
                        "data-test": "chat-indice-artefatos-cartao"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "chat-indice-artefatos__topo ia-texto-corpo d-flex align-center justify-space-between",
                          style: _vm.estiloDoTopo,
                          attrs: { "data-test": "chat-indice-artefatos-topo" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-inline-flex align-center az-gap-xsmall text-truncate",
                              attrs: { title: _vm.titulo }
                            },
                            [
                              _c("span", { staticClass: "text-truncate" }, [
                                _vm._v(_vm._s(_vm.tituloCurto))
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "chat-indice-artefatos__contagem",
                                  attrs: {
                                    "data-test":
                                      "chat-indice-artefatos-contagem"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.total))]
                              )
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "chat-indice-artefatos__acao d-inline-flex align-center justify-center flex-shrink-0",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.rotuloMinimizar,
                                title: _vm.rotuloMinimizar,
                                "data-test": "chat-indice-artefatos-minimizar"
                              },
                              on: { click: _vm.minimizar }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: _vm.ICONE_DE_RECOLHER,
                                  size: _vm.TAMANHO_DO_ICONE_DO_TOPO,
                                  color: "var(--neutral-600)"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm.condensada
                        ? _c(
                            "ul",
                            {
                              staticClass: "chat-indice-artefatos__lista",
                              style: _vm.estiloDaLista,
                              attrs: {
                                "data-test": "chat-indice-artefatos-lista"
                              }
                            },
                            _vm._l(_vm.linhas, function(linha) {
                              return _c("li", { key: linha.identidade }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "chat-indice-artefatos__linha ia-texto-corpo d-flex align-center az-gap-small text-left px-2 py-1",
                                    class: {
                                      "chat-indice-artefatos__linha--ativa":
                                        linha.ativa
                                    },
                                    attrs: {
                                      type: "button",
                                      title: linha.titulo,
                                      "aria-current": linha.ativa
                                        ? "true"
                                        : null,
                                      "data-test":
                                        "chat-indice-artefatos-linha-condensada"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.escolherCondensada(linha)
                                      },
                                      mouseenter: function($event) {
                                        _vm.linhaEmHover = linha.identidade
                                      },
                                      mouseleave: function($event) {
                                        _vm.linhaEmHover = null
                                      }
                                    }
                                  },
                                  [
                                    _c("icon-svg", {
                                      staticClass:
                                        "navbar-main-icon flex-shrink-0",
                                      class: _vm.classesDoIconeCondensado(
                                        linha
                                      ),
                                      attrs: {
                                        name: linha.icone,
                                        size: _vm.TAMANHO_DO_ICONE_DA_LINHA,
                                        color: "primary"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "text-truncate" },
                                      [_vm._v(_vm._s(linha.titulo))]
                                    )
                                  ],
                                  1
                                )
                              ])
                            }),
                            0
                          )
                        : _vm.completa
                        ? _c("ChatIndiceArtefatosCompleta", {
                            staticClass: "chat-indice-artefatos__lista",
                            attrs: {
                              linhas: _vm.linhas,
                              "store-module": _vm.storeModule
                            },
                            on: { abrir: _vm.abrir, fechar: _vm.fecharArtefato }
                          })
                        : _vm._e()
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }